export function getSearchString(): string {
  return window.location.search;
}
